import { useParams } from 'react-router-dom'
import { amenities, properties, propertyImages } from '../data'
import Nav from './Nav'
import "./Property.css"
import { LuBedDouble } from 'react-icons/lu'
import { PiBathtub } from 'react-icons/pi'
import { BiArea } from 'react-icons/bi'


const Property = () => {

    const {id}  = useParams()
    const numericId = Number(id);
  // const property = properties.find((property) => property.id === parseInt(id))
    const property =properties.filter((property) => property.id === numericId)[0];
    
  return (
    <div>
      
      <div className='property-container'>
        <div className='property-wrapper'>
            <h1 className='property-heading'>
                {property.type} for {property.title} in {property.address}
            </h1>
            <div className='property-images'>
                <div className='main-image'>
                     <img src={property.image} alt='' /> 
                    
                </div>
                <div className='small-images'>
                    {propertyImages.slice(1).map((image, index) => (
                        <img src={image.image} key={index}  alt=''/>

                    ))}
                </div>
            </div>

            <div className='property-details'>
                <h1>{property.price}</h1>
                <div className='property-rooms'>
                    <span>
                        <LuBedDouble className='icon'  />
                        <p>{property.bedrooms} Bedrooms </p> 
                    </span>
                    <span>
                        <PiBathtub className='icon' />
                        {property.bathrooms} Bathrooms
                    </span>
                    <span>
                        <BiArea className="icon"/>
                        <p>{property.size} (sqm)</p>
                    </span>
                </div>
            </div>
            <div className='property-amenities'>
                <h1>Amenities</h1>
                <div className='amenities'>
                    {amenities.map((item)=>(
                        <div key={item.id} className='amenity'>
                            <span className='icon'>{item.iocn}</span>
                            <span>{item.title}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
      </div>
      </div>
  )
}

export default Property



